import { Typography } from "@mui/material";
import FaqAccordion from "component/accordion/faqAccordion/FaqAccordion";
import React from "react";
import styles from "./FaqContent.module.css";
import { Container } from "@mui/system";


const faqs = [
  {
    question: "What is the Stanbic IBTC Home loan?",
    answer:
      "Stanbic IBTC Home Loan offers the opportunity to acquire a completed residential property with valid proof of ownership OR use an existing property to raise funds to purchase another property (Equity release).",
  },
  {
    question: "What are the acceptable title documents?",
    answer:
      "Certificate of Occupancy, Deed of Assignment, Deed of Sublease, Deed of Transfer, Deed of Consent, Deed of Conveyance and Deed of Assent.",
  },
  {
    question:
      "I need financing to purchase an off plan residential unit, is this covered under the Stanbic IBTC Home Loan?",
    answer:
      "Off plan mortgage financing will be considered for properties developed and marketed by pre-approved construction companies. This is however subject to approval.",
  },
  {
    question:
      "What is the minimum loan amount I can access on the Stanbic IBTC Home Loan?",
    answer: "N5 million (Five Million Naira Only).",
  },
  {
    question: "What is the maximum loan amount?",
    answer:
      "Maximum loan amount is subject to acceptable Installment to Income (ITI) and Debt Service Ratio (DSR) limits for salaried individuals. Repayment capacity will be based on Customer’s cashflow for non-salaried persons",
  },
  // {
  //   question: "Do I have to make a deposit to access the loan?",
  //   answer:
  //     "Yes, this deposit is also known as “Equity contribution” and only applicable to Property Purchase. A minimum deposit of 20% of property value is required as the customer’s contribution. This deposit is not required for Equity Release.",
  // },
  {
    question:
      "What collateral must be provided for the Stanbic IBTC Home Loan?",
    answer:
      "A legal mortgage on the property financed for the customer will serve as collateral for the loan.",
  },
  {
    question:
      "What are the repayment options on the Stanbic IBTC Bank Home Loan?",
    answer:
      "Repayments can be done in Equal Monthly Principal Repayments. Where a Customer earns guaranteed allowances Quarterly/Biannually/Annually, repayment will be structured to accommodate these allowances, with a portion of the principal amount repaid monthly.",
  },
  {
    question: "Who is eligible for home loan?",
    answer:
      "Stanbic IBTC Home Loans can be accessed by Salaried individuals and Business owners. Salaried individuals will be required to domicile their salary with Stanbic IBTC Bank and must have received last salary into this transaction account. Business owners must provide verifiable cashflows.",
  },
  {
    question: "What are the age limits?",
    answer:
      "Applying customers must be aged at least twenty-one (21) but not older than 60 years on expiration of the facility.",
  },
  {
    question: "What is the minimum length of employment required?",
    answer:
      "Customers must have a minimum of 6months employment history with the current employer and must be a confirmed permanent staff.",
  },
  {
    question: "What is ITI and DSR?",
    answer:
      "Both ITI and DSR are used in determining loan amount that can be accessed by a customer. ITI means Installment-to-income which evaluates the customer’s ability to repay the loan, relative to the net monthly income earned. The limit is 35%. DSR means Debt Service ratio. This is used to analyze ability to repay all total monthly repayments, including the home loan you are applying for. The limit is 50%.",
  },
  {
    question: "What is the Stanbic IBTC Home loan tenure?",
    answer:
      "Maximum of 20 years (subject to years to retirement age of 60years).",
  },
  {
    question:
      "What documents do I need to submit to access the Stanbic IBTC Home Loan?",
    answer:
      "The documents required include: i. Completed Home Loan application form. ii. Offer letter for sale from Vendor.iii. Copy of company (work) ID card.iv. Copy of valid photo identification (Int’l passport/driver’s license).v. Letter of introduction from Employer (stating salary and confirmation status). vi.Recommendation letter from professional body, institution, or company, United Nations and its agencies (Diaspora). vii. Curriculum vitae (Diaspora). viii. Credit scores from approved agencies; Equifax, Experian, Fico, etc. (Diaspora). ix. Copy of the title documents to the property.x. Valuation report from any of the Bank’s approved Valuer.xi. Satisfactory search report.xii. Recent 3 months pay slips.x. Recent 6 months bank statements with evidence of salary payment.",
  },
  {
    question: "What is the cost of perfection on the Home Loan?",
    answer:
      "The cost of perfection is dependent on the state where the valuation of the property was done, the size of the property, location, and loan amount. This cost is payable to the government lands registry to process registration of deed in customer’s favour.",
  },
  {
    question: "Can I pay down before the expiration of the facility?",
    answer:
      "Yes, customers can prepay or part-liquidate the facility at no penalty",
  },
  {
    question: "Can I access the loan to purchase lands only?",
    answer:
      "You can access our personal loan variants to purchase a land. ",
  },
  {
    question: "Are joint applications allowed?",
    answer:
      "Yes, joint applications are allowed with a spouse only. Each applicant will be required to domicile salaries with Stanbic IBTC Bank and fulfill all conditions to access the home loan",
  },
  {
    question: "What are the approved locations for the Stanbic IBTC Home loan?",
    answer:
      "All 36 states of the Federation including Federal Capital Territory (FCT).",
  },
  {
    question: "Can I get more money after a period of repayment?",
    answer:
      "Yes. Customers can top-up their loans subject to a 15% Principal pay-down.",
  },
  {
    question: "Is there an insurance cover on the Property?",
    answer:
      "Yes, there is a mandatory insurance cover on the Property as well as life insurance on the applicant. The rates for the Fire and Special Perils are negotiable based on the replacement value of the building.",
  },
   {
    question: "What is the Stanbic IBTC Diaspora mortgage?",
    answer:
      "Stanbic IBTC Diaspora Home Loan allows Nigerian professionals living in the USA, UK, Canada, and Saudi Arabia and other countries to purchase residential properties in Nigeria, with flexible repayment options and terms.",
  },
   {
    question: "Do I have to make a deposit to access the diaspora mortgage?",
    answer: "Yes, this deposit is also known as “Equity contribution” and a minimum of 25% of the property value is required.",
  },
  {
    question: "Who is eligible for the Diaspora mortgage?",
    answer: "Nigerians’ resident in the following professions: Medical, Engineering, Attorneys, IT Consulting, Financial Planning, Travels and Tours, Finance, Agriculture, Education, Oil & Gas, Media, Consulting, Leasing, Hospitality, Investment Banking, Accountancy, NFL, Architecture and others.",
  },
   {
    question: "What is the minimum salary required to key into the Diaspora mortgage? ",
    answer: "Creditworthy individuals who are employed and earn a minimum net monthly income equivalent to ₦500,000 for an outright purchase or for an equity release solution.",
  },
   {
    question: "What is Pension Backed Specialized Mortgage?",
    answer: "This is the outright purchase of turnkey properties using up to 25% of the Retirement Savings Account (RSA) balance to meet equity contribution requirements. (Retirement Savings Account can be with any accredited Pension Fund Administrator).",
  },
    {
    question: "Who is eligible for the Specialized Mortgage Solution? ",
    answer: "Employed Nigerians with an active Retirement Savings Account (RSA), must have contributed for at least 60 months and must be below three years to official retirement age.",
  },

  {
    question: "Do I have to make a deposit to access the specialized mortgage? ",
    answer: "Yes, this deposit is also known as “Equity contribution” and is only applicable to Property Purchase. A minimum deposit of 15% of the property value is required through the 25% RSA balance or a combination of cash and 25% RSA balance.",
  },

   {
    question: "Do I need to have my pension account with Stanbic IBTC to qualify for a specialized mortgage? ",
    answer: "No, the specialized mortgage can be accessed by qualified applicants with a Retirement Savings Account managed by any Pension Fund Administrator.",
  },

  {
    question: "What is the minimum monthly salary allowed to key into the specialized mortgage? ",
    answer: "₦200,000 (Two Hundred Thousand Naira Only).",
  },
   {
    question: "Must I purchase a home to access 25% from my Pension Account?",
    answer: "Yes, the guidelines issued by the National Pension Commission (PenCom) state that RSA holders can access up to 25% of their retirement savings account balance to facilitate equity contributions for residential mortgage.",
  },
   {
    question: "Can joint applicants access specialized mortgages where both parties have different Pension Fund Administrators?",
    answer: "Yes, joint applications with a spouse are acceptable even where applicants have RSAs managed by different Pension Fund Administrators.",
  },
  //  {
  //   question: "Off-plan Mortgage Solution",
  //   answer: "You can send us an email on homeloansunit@mail.standardbank.com",
  // },
   {
    question: "What is the Off-plan Mortgage Solution?",
    answer: "This is the purchase of semi-completed units or homes under construction from bank-approved developers.",
  },
   {
    question: "How can I access the Off-plan mortgage? ",
    answer: "Once a property is listed by a reliable and accredited developer who can be vetted and onboarded, or any of our reputable onboarded developers, and the required documents are submitted, the process begins.",
  },

   {
    question: "Do I have to make a deposit to access the off-plan mortgage loan?",
    answer: "Yes, this deposit is also known as “Equity contribution”. A minimum deposit of 30% of the property value is required for this variant.",
  },
   {
    question: "What is the Help-To-Own Home Loan?",
    answer: "This variant aims to provide creditworthy Nigerians who are first-time homeowners and are employed in Nigeria and the Diaspora the opportunity to access affordable rates for an outright purchase.",
  },
   {
    question: "What is the maximum property price allowed for the Help-to-Own Home Loan?",
    answer: "This initiative is to empower Nigerians home and abroad to become homeowners. The property value is capped at ₦70,000,000 (Seventy Million Naira) and 40% of the loan amount is priced at 4.84% per annum fixed interest rate for the life of the facility.",
  },
   {
    question: "How much deposit is required for this Help-to-Own Home Loan? ",
    answer: "The equity contribution for this home loan is a minimum 10% Equity Contribution (by cash or by 25% RSA for eligible applications). Customers can choose to do more than this where desired.",
  },
   {
    question: "What are the interest rates for the Help-to-Own Home Loan?",
    answer: "The interest rates for this initiative is affordable and is charged at 4.84% per annum on 40% of the loan while prevailing commercial rate is charged on 50% of the loan amount and customer provides 10% as equity contribution.",
  },
  
  {
    question: "Where do we send inquiries to?",
    answer: "You can send us an email on homeloansunit@mail.standardbank.com",
  },
];

function FaqContent({ type }) {
  return (
    <div className={styles.faq_content}>
      <div
        className={`${styles.heading} ${
          type === "faq_page" && styles.heading_transparent
        }`}
      >
        <Typography variant="h6">Frequently asked questions</Typography>
        <Typography>Everything you need to know about the product.</Typography>
      </div>
      <div className={`${styles.body}  ${type === 'faq_page' ? styles.rm_overflow  : null}`}>          
      <Container maxWidth='sm'>
          {faqs.map((faq, index) => {
          if (
            faq.question ===
            "What documents do I need to submit to access the Stanbic IBTC Home Loan?"
          ) {
            return (
              <FaqAccordion
              index={index}
                key={index}
                question={faq.question}
                answer={
                  <div>
                    <Typography>The documents required include:</Typography>
                    <Typography>
                      i. Completed Home Loan application form.
                    </Typography>
                    <Typography>
                      ii. Offer letter for sale from Vendor.
                    </Typography>
                    <Typography>
                      iii. Copy of company (work) ID card.
                    </Typography>
                    <Typography>
                      iv. Copy of valid photo identification (Int’l
                      passport/driver’s license).
                    </Typography>
                    <Typography>
                      v. Letter of introduction from Employer (stating salary
                      and confirmation status).
                    </Typography>
                    <Typography>
                      vi. Recommendation letter from professional body, institution, or company, United Nations and its agencies (Diaspora).
                    </Typography>
                    <Typography>
                      vii. Curriculum vitae (Diaspora).
                    </Typography>
                    <Typography>
                      viii.	Credit scores from approved agencies; Equifax, Experian, Fico, etc. (Diaspora).
                    </Typography>
                    <Typography>
                      ix. Copy of the title documents to the property.
                    </Typography>
                    <Typography>
                      x. Valuation report from any of the Bank’s approved
                      Valuer.
                    </Typography>
                    <Typography>
                      xi. Satisfactory search report.
                    </Typography>
                    <Typography>
                      xii. Recent 3 months payslips and 6 months bank statements with evidence of salary payment.
                    </Typography>
                  </div>
                }
              />
            );
          } else if (faq.question === "Where do we send inquiries to?") {
            return (
              <FaqAccordion
              index={index}
                key={index}
                question={faq.question}
                answer={
                  <Typography>
                    You can send us an email on{" "}
                    <a href="mailto:homeloansunit@mail.standardbank.com">
                      homeloansunit@mail.standardbank.com
                    </a>{" "}
                  </Typography>
                }
              />
            );
          } else {
            return (
              <FaqAccordion
              index={index}
                key={index}
                question={faq.question}
                answer={<Typography>{faq.answer}</Typography>}
              />
            );
          }
        })}
          </Container>
       
      </div>
    </div>
  );
}

export default FaqContent;
